<div class="container" (click)="input.click()" [class.showing-suggestions]="showingSuggestions" [class.no-search-view]="noSearchView" #container>
    <div class="search-input-container">
        <app-icon icon="search" [size]="24" class="icon" [noMove]="true"></app-icon>
        
        <input 
            [(ngModel)]="value"
            type="text" 
            [placeholder]="placeholder" 
            class="input" 
            #input 
            (click)="openSearchView()"
            (input)="emitInputChange($event)"
            (keyup.enter)="emitSearch()"
            (focus)="showingSuggestions = true">
    </div>

    @if (!isMobile.getIsMobile() && showingSuggestions && !noSearchView) {
        <div class="suggestions">
            <mat-divider></mat-divider>
            <ng-content select="[desktop-content]"></ng-content>
        </div>
    }
</div>

<dialog class="search-view" #searchView>
    <div class="search-view-container">
        <div class="search-view-content">
            <div class="search-view-header">
                <button mat-icon-button (click)="closeSearchView()">
                    <app-icon icon="arrow_back" [noMove]="true"></app-icon>
                </button>
    
                <input 
                    [(ngModel)]="value"
                    type="text" 
                    [placeholder]="placeholder" 
                    class="input" 
                    enterkeyhint="search"
                    #searchViewInput 
                    (click)="openSearchView()" 
                    (input)="emitInputChange($event)"
                    (keyup.enter)="emitSearch()">
            </div>
            <mat-divider></mat-divider>
            @if (isMobile.getIsMobile()) {
                <div class="search-view-content">
                    <ng-content select="[mobile-content]"></ng-content>
                </div>
            }
        </div>
    </div>
</dialog>
